export default "__VITE_ASSET__Ln2oD1E9__"